import { get, post } from "@/application/api";
import { AxiosPromise } from "axios";
import {
  PasswordForgottenRequestResource,
  PasswordResetRequestResource,
  ProfileShowResource,
  UserAuthorizeRequestResource,
} from "@/modules/shared/authorisation/types";

export const fetchProfile = (): AxiosPromise<{ data: ProfileShowResource }> => {
  return get("profile");
};

export const login = (
  data: Partial<UserAuthorizeRequestResource>,
): AxiosPromise<{ data: { token: string } }> => post("auth/login", data);

export const forgotten = (data: Partial<PasswordForgottenRequestResource>) =>
  post("auth/password/forgotten", data);

export const reset = (data: Partial<PasswordResetRequestResource>) =>
  post("auth/password/reset", data);

export const logout = () => post("auth/logout");
